import { useSyncExternalStore } from 'react';
/**
 * Функция-заглушка подписки для useSyncExternalStore.
 */
const subscribe = () => () => {
    // ничего не делаем
};
/**
 * Стейт на стороне клиента, который всегда возвращает false (не SSR).
 */
const getSnapshot = () => false;
/**
 * Стейт на стороне сервера, который всегда возвращает true (это SSR).
 */
const getServerSnapshot = () => true;
/**
 * Хук для определения, выполняется ли код в данный момент во время серверного рендеринга (SSR).
 *
 * @returns `true`, если выполняется на сервере во время SSR или во время гидратации на клиенте, `false` после завершения гидратации
 *
 * @example
 * ```tsx
 * function MyComponent() {
 *   const isSsr = useIsSsr();
 *
 *   if (isSsr) {
 *     return <div>Серверный рендеринг...</div>;
 *   }
 *
 *   return <div>Отрендерено на клиенте!</div>;
 * }
 * ```
 */
export function useIsSsr() {
    return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
